(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__simplyScrollbarWidthInitialized) return;

    window.__simplyScrollbarWidthInitialized = true;

    const root = document.documentElement;
    let frameId = 0;
    let scrollbarWidth = -1;

    const updateScrollbarWidth = () => {
      frameId = 0;

      const nextScrollbarWidth = window.innerWidth - root.clientWidth;
      if (nextScrollbarWidth === scrollbarWidth) return;

      scrollbarWidth = nextScrollbarWidth;
      root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    };

    const scheduleUpdate = () => {
      if (frameId !== 0) return;

      frameId = window.requestAnimationFrame(updateScrollbarWidth);
    };

    updateScrollbarWidth();
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(root);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-bubble"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cartBubbleUpdateInit) return;
    window.__cartBubbleUpdateInit = true;

    const renderCartBubble = (bubble, itemCount) => {
      const count = bubble.querySelector('[ref="cartBubbleCount"]');
      if (!count) return;

      const limit = Number(bubble.dataset.cartBubbleLimit || 0);
      const shouldShowCount = limit === 0 || itemCount < limit;

      count.textContent = shouldShowCount ? String(itemCount) : '';
      count.classList.toggle('hidden', itemCount === 0);
      bubble.classList.toggle('visually-hidden', itemCount === 0);
      bubble.toggleAttribute('data-maintain-ratio', itemCount <= 99);
    };

    document.addEventListener('cart:update', (event) => {
      const resourceItemCount = Number(event.detail?.resource?.item_count);
      const dataItemCount = Number(event.detail?.data?.itemCount);
      const itemCount = Number.isFinite(resourceItemCount)
        ? resourceItemCount
        : Number.isFinite(dataItemCount)
        ? dataItemCount
        : 0;

      document.querySelectorAll('[data-cart-bubble]').forEach((bubble) => {
        renderCartBubble(bubble, itemCount);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-recently-viewed-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cart-drawer-recently-viewed-panel')) return;

    const RECENTLY_VIEWED_STORAGE_KEY = 'viewedProducts';
    const RECENTLY_VIEWED_SECTION_ID = 'cart-recently-viewed';
    const RECENTLY_VIEWED_LIMIT = 4;

    class CartDrawerRecentlyViewedPanel extends HTMLElement {
      _abortController = null;
      _requestId = 0;

      connectedCallback() {
        this._handleClick = this._handleClick.bind(this);
        this.addEventListener('click', this._handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._handleClick);
      }

      _reportError(message, error) {
        if (error instanceof Error) {
          console.error(`[cart-drawer-recently-viewed-panel] ${message}`, error);
          return;
        }

        console.error(`[cart-drawer-recently-viewed-panel] ${message}`, error);
      }

      _getItemsContainer() {
        const itemsContainer = this.querySelector('[data-cart-recently-viewed-items]');
        return itemsContainer instanceof HTMLElement ? itemsContainer : null;
      }

      _getRecentlyViewedProductIds() {
        try {
          const parsed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY) || '[]');
          if (!Array.isArray(parsed)) return [];

          return parsed
            .map((id) => String(id).trim())
            .filter((id) => id !== '')
            .slice(0, RECENTLY_VIEWED_LIMIT);
        } catch (error) {
          this._reportError('Failed to parse recently viewed products from localStorage.', error);
          return [];
        }
      }

      _setLoadingState(isLoading) {
        this.classList.toggle('loading', isLoading);
        this.classList.toggle('loaded', !isLoading);
      }

      _setItemLoadingState(button, isLoading) {
        const action = button.closest('[data-cart-recently-viewed-action]');
        if (!(action instanceof HTMLElement)) return;

        const loading = action.querySelector('[data-cart-recently-viewed-loading]');

        action.classList.toggle('is-loading', isLoading);
        button.style.opacity = isLoading ? '0' : '1';
        button.style.pointerEvents = isLoading ? 'none' : '';

        if (loading instanceof HTMLElement) {
          loading.style.opacity = isLoading ? '1' : '0';
          loading.style.pointerEvents = isLoading ? 'auto' : 'none';
        }
      }

      async _handleClick(event) {
        if (!(event.target instanceof Element)) return;

        const addButtonWrapper = event.target.closest('[data-cart-recently-viewed-add-button]');
        if (!(addButtonWrapper instanceof HTMLElement) || !this.contains(addButtonWrapper)) return;

        const button = addButtonWrapper.querySelector('button');
        if (!(button instanceof HTMLButtonElement)) return;

        event.preventDefault();

        if (button.disabled) return;

        const variantId = addButtonWrapper.dataset.variantId;
        const productId = addButtonWrapper.dataset.productId;

        if (!variantId) return;

        button.disabled = true;
        this._setItemLoadingState(button, true);

        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [];

        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });

        try {
          const addResponse = await fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });

          const addData = await addResponse.json();
          if (addData.status) return;

          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: variantId,
                data: {
                  source: 'cart-recently-viewed-item',
                  itemCount: cart.item_count,
                  productId,
                  sections: addData.sections,
                },
              },
            })
          );
        } catch (error) {
          this._reportError('Failed to add recently viewed product to cart.', error);
        } finally {
          button.disabled = false;
          this._setItemLoadingState(button, false);
        }
      }

      async loadRecentlyViewedProducts() {
        const targetContainer = this._getItemsContainer();
        if (!(targetContainer instanceof HTMLElement)) return;

        const viewedProductIds = this._getRecentlyViewedProductIds();
        if (viewedProductIds.length === 0) {
          this._abortController?.abort();
          this._abortController = null;
          targetContainer.replaceChildren();
          this._setLoadingState(false);
          return;
        }

        const currentRequestId = ++this._requestId;
        this._abortController?.abort();
        this._abortController = new AbortController();
        this._setLoadingState(true);

        const searchRoute = window.Theme?.routes?.search_url || '/search';
        const sectionUrl = new URL(searchRoute, window.location.origin);
        sectionUrl.searchParams.set('q', viewedProductIds.map((id) => `id:${id}`).join(' OR '));
        sectionUrl.searchParams.set('resources[type]', 'product');
        sectionUrl.searchParams.set('section_id', RECENTLY_VIEWED_SECTION_ID);

        try {
          const response = await fetch(sectionUrl.toString(), {
            headers: {
              Accept: 'text/html',
            },
            signal: this._abortController.signal,
          });
          if (!response.ok) {
            throw new Error(`Recently viewed request failed with status ${response.status}.`);
          }

          const html = await response.text();
          if (currentRequestId !== this._requestId) return;

          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextItemsContainer = parsedDocument.querySelector('[data-cart-recently-viewed-items]');
          if (!(nextItemsContainer instanceof HTMLElement)) {
            targetContainer.replaceChildren();
            return;
          }

          targetContainer.replaceChildren(...Array.from(nextItemsContainer.children).map((item) => item.cloneNode(true)));
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
          this._reportError('Failed to render recently viewed products.', error);
        } finally {
          if (currentRequestId === this._requestId) {
            this._abortController = null;
            this._setLoadingState(false);
          }
        }
      }
    }

    customElements.define('cart-drawer-recently-viewed-panel', CartDrawerRecentlyViewedPanel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cartDrawerShell) {
      window.__cartDrawerShell.refresh?.();
      return;
    }

    window.__cartDrawerShell = {};
    const DRAWER_SELECTOR = '.cart-drawer-shell.header-drawer-shell--cart';
    const initializedDrawers = new WeakSet();
    const getDrawer = () => document.querySelector(DRAWER_SELECTOR);

    const isDrawerOpen = (drawer) => {
      return (
        drawer instanceof HTMLElement &&
        drawer.classList.contains('is-open') &&
        drawer.getAttribute('aria-hidden') === 'false'
      );
    };

    const hydrateDrawerContent = (drawer) => {
      if (!(drawer instanceof HTMLElement)) return false;
      if (drawer.dataset.cartDrawerHydrated === 'true') return true;

      const component = drawer.querySelector('cart-items-component');
      if (!(component instanceof HTMLElement)) return false;

      const template = component.querySelector(':scope > template[data-cart-drawer-content-template]');
      if (!(template instanceof HTMLTemplateElement)) return false;

      const clone = document.importNode(template.content, true);
      component.replaceChildren(clone);
      drawer.dataset.cartDrawerHydrated = 'true';

      if (typeof component.updatedCallback === 'function') {
        component.updatedCallback();
      }

      return true;
    };

    const hydrateAndActivateDrawer = (drawer) => {
      if (!isDrawerOpen(drawer)) return;
      if (!hydrateDrawerContent(drawer)) return;

      const defaultTab = drawer.querySelector('[data-cart-tab][aria-expanded="true"]');
      const firstTab = drawer.querySelector('[data-cart-tab]');
      setActiveTab(drawer, defaultTab || firstTab);
    };

    const activateMiniCartTab = (drawer) => {
      if (!(drawer instanceof HTMLElement)) return;
      hydrateDrawerContent(drawer);

      const miniCartTab = drawer.querySelector('[id^="MiniCartTab-"][data-cart-tab]');
      if (!(miniCartTab instanceof HTMLElement)) return;

      setActiveTab(drawer, miniCartTab);
    };

    const setActiveTab = (drawer, activeTab) => {
      if (!drawer || !activeTab) return;
      const tabs = drawer.querySelectorAll('[data-cart-tab]');
      const panels = drawer.querySelectorAll('[data-cart-panel]');
      const targetPanelId = activeTab.getAttribute('aria-controls');
      const footer = drawer.querySelector('[data-cart-footer]');
      const miniCartPanel = drawer.querySelector('[id^="MiniCart-"][data-cart-panel]');
      const recentlyViewedPanel = drawer.querySelector('[data-cart-recently-viewed-panel]');

      tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetPanelId;
      });

      if (footer) {
        footer.hidden = !miniCartPanel || targetPanelId !== miniCartPanel.id;
      }

      if (targetPanelId && targetPanelId.indexOf('RecentlyViewed-') === 0) {
        recentlyViewedPanel?.loadRecentlyViewedProducts?.();
      }
    };

    const initializeDrawer = (drawer) => {
      if (!(drawer instanceof HTMLElement)) return;
      if (initializedDrawers.has(drawer)) return;

      initializedDrawers.add(drawer);

      const observer = new MutationObserver(() => {
        hydrateAndActivateDrawer(drawer);
      });

      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden'],
      });

      hydrateAndActivateDrawer(drawer);
    };

    const refreshDrawers = (root = document) => {
      if (root instanceof Element && root.matches(DRAWER_SELECTOR)) {
        initializeDrawer(root);
      }

      if ('querySelectorAll' in root) {
        root.querySelectorAll(DRAWER_SELECTOR).forEach((drawer) => {
          initializeDrawer(drawer);
        });
      }
    };

    const sectionsObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          refreshDrawers(node);
        });
      });
    });

    if (document.body) {
      sectionsObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    document.addEventListener('theme:section:rendered', (event) => {
      const sectionId = event.detail?.sectionId;
      if (typeof sectionId !== 'string' || sectionId === '') return;

      const section = document.getElementById(`shopify-section-${sectionId}`);
      if (!(section instanceof HTMLElement)) return;

      refreshDrawers(section);
      section.querySelectorAll(DRAWER_SELECTOR).forEach((drawer) => {
        hydrateAndActivateDrawer(drawer);
      });
    });

    document.addEventListener('cart:update', (event) => {
      const resourceItemCount = Number(event.detail?.resource?.item_count);
      const dataItemCount = Number(event.detail?.data?.itemCount);
      const itemCount = Number.isFinite(resourceItemCount)
        ? resourceItemCount
        : Number.isFinite(dataItemCount)
        ? dataItemCount
        : 0;

      document.querySelectorAll('[data-cart-drawer-item-count]').forEach((countElement) => {
        const itemLabel =
          itemCount === 1
            ? countElement.dataset.itemCountLabelOne || 'item'
            : countElement.dataset.itemCountLabelOther || 'items';
        countElement.textContent = `(${itemCount} ${itemLabel})`;
      });

      const source = event.detail?.data?.source;
      if (source !== 'cart-recently-viewed-item') return;

      const drawer = getDrawer();
      if (!(drawer instanceof HTMLElement)) return;

      activateMiniCartTab(drawer);
    });

    const drawerController = window.__headerDrawerShell;

    window.__cartDrawerShell.open = () => drawerController?.open?.(getDrawer()) || null;
    window.__cartDrawerShell.close = () => drawerController?.close?.(getDrawer());
    window.__cartDrawerShell.refresh = refreshDrawers;
    window.__cartDrawerShell.syncScrollLock = () => drawerController?.syncScrollLock?.();
    refreshDrawers();

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-cart-tab]');
      if (tab) {
        const drawer = tab.closest(DRAWER_SELECTOR);
        hydrateDrawerContent(drawer);
        setActiveTab(drawer, tab);
        return;
      }

      const openTrigger = event.target.closest('[data-drawer-open="cart-drawer"], [data-cart-drawer-open]');
      if (openTrigger) {
        queueMicrotask(() => {
          const drawer = getDrawer();
          if (!(drawer instanceof HTMLElement) || !isDrawerOpen(drawer)) return;

          initializeDrawer(drawer);
          hydrateAndActivateDrawer(drawer);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-free-shipping-hint"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-free-shipping-hint')) {
    const freeShippingHintState = (window.__cartFreeShippingHintState ??= new Map());

    class CartFreeShippingHint extends HTMLElement {
      static get observedAttributes() {
        return ['data-message', 'data-progress', 'data-state'];
      }

      connectedCallback() {
        this.messageElement = this.querySelector('[data-free-shipping-message]');
        this.progressElement = this.querySelector('[data-free-shipping-progress]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.instanceKey = this.dataset.instanceKey || '';
        this.currentMessage = this.dataset.message || '';
        this.currentProgress = this.#getProgressValue();

        const previousState = this.instanceKey ? freeShippingHintState.get(this.instanceKey) : null;

        if (
          previousState &&
          this.reduceMotion.matches === false &&
          (previousState.message !== this.currentMessage || previousState.progress !== this.currentProgress)
        ) {
          this.#render(previousState.message, previousState.progress);

          window.requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.#animateMessage(previousState.message, this.currentMessage);
            this.#animateProgress(previousState.progress, this.currentProgress);
          });
        } else {
          this.#render(this.currentMessage, this.currentProgress);
        }
      }

      disconnectedCallback() {
        this.messageAnimationOut?.cancel();
        this.messageAnimationIn?.cancel();

        if (!this.instanceKey) return;

        freeShippingHintState.set(this.instanceKey, {
          message: this.currentMessage,
          progress: this.currentProgress,
        });
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isConnected || oldValue === newValue) return;
        if (!this.messageElement || !this.progressElement) return;

        if (name === 'data-progress') {
          this.#animateProgress(this.currentProgress, this.#getProgressValue());
          this.currentProgress = this.#getProgressValue();
          return;
        }

        if (name === 'data-message') {
          this.#animateMessage(this.currentMessage, newValue || '');
          this.currentMessage = newValue || '';
        }
      }

      #getProgressValue() {
        const progress = Number.parseFloat(this.dataset.progress || '0');
        if (Number.isNaN(progress)) return 0;
        return Math.max(0, Math.min(progress, 100));
      }

      #render(message, progress) {
        if (this.messageElement) this.messageElement.textContent = message;
        if (this.progressElement) this.progressElement.style.setProperty('--progress', `${progress}%`);
      }

      #animateMessage(previousMessage, nextMessage) {
        if (!this.messageElement || previousMessage === nextMessage) return;

        if (this.reduceMotion.matches) {
          this.messageElement.textContent = nextMessage;
          return;
        }

        this.messageAnimationOut?.cancel();
        this.messageAnimationIn?.cancel();

        this.messageAnimationOut = this.messageElement.animate(
          [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(-0.25rem)' },
          ],
          {
            duration: 65,
            easing: 'ease',
            fill: 'forwards',
          }
        );

        this.messageAnimationOut.finished
          .then(() => {
            if (!this.isConnected || !this.messageElement) return;

            this.messageElement.textContent = nextMessage;

            this.messageAnimationIn = this.messageElement.animate(
              [
                { opacity: 0, transform: 'translateY(0.25rem)' },
                { opacity: 1, transform: 'translateY(0)' },
              ],
              {
                duration: 95,
                easing: 'ease',
                fill: 'forwards',
              }
            );

            return this.messageAnimationIn.finished;
          })
          .catch(() => {})
          .finally(() => {
            if (!this.messageElement) return;
            this.messageElement.style.opacity = '';
            this.messageElement.style.transform = '';
          });
      }

      #animateProgress(previousProgress, nextProgress) {
        if (!this.progressElement || previousProgress === nextProgress) return;
        this.progressElement.style.setProperty('--progress', `${previousProgress}%`);

        window.requestAnimationFrame(() => {
          if (!this.isConnected || !this.progressElement) return;
          this.progressElement.style.setProperty('--progress', `${nextProgress}%`);
        });
      }
    }

    customElements.define('cart-free-shipping-hint', CartFreeShippingHint);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('header-menu-drawer')) {
      return;
    }

    class HeaderMenuDrawer extends HTMLElement {
      constructor() {
        super();
        this.handleAnchorLinkClick = this.handleAnchorLinkClick.bind(this);
        this.handleDrawerClose = this.handleDrawerClose.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleAnchorLinkClick);
        this.addEventListener('header-drawer:close', this.handleDrawerClose);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleAnchorLinkClick);
        this.removeEventListener('header-drawer:close', this.handleDrawerClose);
      }

      handleAnchorLinkClick(event) {
        if (!(event.target instanceof Element)) {
          return;
        }

        const link = event.target.closest('a[href]');

        if (!(link instanceof HTMLAnchorElement)) {
          return;
        }

        const url = new URL(link.href, window.location.href);

        if (url.hash === '') {
          return;
        }

        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) {
          return;
        }

        window.__headerDrawerShell?.close?.(this);
      }

      handleDrawerClose(event) {
        if (event.target !== this) {
          return;
        }

        this.querySelectorAll('.custom-header__menu-drawer-details[open]').forEach((item) => {
          item.removeAttribute('open');
        });
      }
    }

    customElements.define('header-menu-drawer', HeaderMenuDrawer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-menu-item"] && !Shopify.designMode) return;
  try {
    if (!window.headerMenuItemToggleInitialized) {
    window.headerMenuItemToggleInitialized = true;

    const getMenuGroup = (target) => {
      if (!(target instanceof Element)) {
        return null;
      }

      return target.closest('[data-header-menu-item-group]');
    };

    const setMenuExpanded = (group, expanded) => {
      if (!(group instanceof HTMLElement)) {
        return;
      }

      const trigger = group.querySelector('[data-header-menu-trigger]');

      if (!(trigger instanceof HTMLButtonElement)) {
        return;
      }

      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    const collapseHeaderMenuItems = () => {
      document.querySelectorAll('[data-header-menu-trigger][aria-expanded="true"]').forEach((item) => {
        item.setAttribute('aria-expanded', 'false');
      });
    };

    document.addEventListener('mouseover', (event) => {
      const group = getMenuGroup(event.target);

      if (!(group instanceof HTMLElement)) {
        return;
      }

      setMenuExpanded(group, true);
    });

    document.addEventListener('mouseout', (event) => {
      const group = getMenuGroup(event.target);

      if (!(group instanceof HTMLElement)) {
        return;
      }

      if (group.contains(event.relatedTarget)) {
        return;
      }

      setMenuExpanded(group, false);
    });

    document.addEventListener('focusin', (event) => {
      const group = getMenuGroup(event.target);

      if (!(group instanceof HTMLElement)) {
        return;
      }

      setMenuExpanded(group, true);
    });

    document.addEventListener('focusout', (event) => {
      const group = getMenuGroup(event.target);

      if (!(group instanceof HTMLElement)) {
        return;
      }

      if (group.contains(event.relatedTarget)) {
        return;
      }

      setMenuExpanded(group, false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      collapseHeaderMenuItems();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lazy-image"] && !Shopify.designMode) return;
  try {
    {
    class LazyImage extends HTMLImageElement {
      connectedCallback() {
        this.wrapper = this.closest('[data-lazy-image]');
        this.markLoading();

        this.addEventListener('load', this.markLoaded, { once: true });
        this.addEventListener('error', this.markLoaded, { once: true });

        if (this.complete) {
          this.markLoaded();
        }
      }

      markLoading = () => {
        if (!(this.wrapper instanceof HTMLElement)) return;

        if (this.complete) {
          this.markLoaded();
          return;
        }

        this.wrapper.classList.add('loading');
        this.wrapper.classList.remove('loaded');
        this.addEventListener('load', this.markLoaded, { once: true });
        this.addEventListener('error', this.markLoaded, { once: true });
      };

      markLoaded = () => {
        if (!(this.wrapper instanceof HTMLElement)) return;

        this.wrapper.classList.remove('loading');
        this.wrapper.classList.add('loaded');
      };
    }

    if (!customElements.get('lazy-image')) {
      customElements.define('lazy-image', LazyImage, { extends: 'img' });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('localization-drawer') && customElements.get('localization-auto-suggestion')) return;

    const getDrawers = () => Array.from(document.querySelectorAll('[data-localization-drawer-root]'));
    const getLocalizationId = (element) => element?.dataset.localizationId || '';
    const getRootForm = (element) => {
      const localizationId = getLocalizationId(element);
      if (localizationId === '') return null;
      return document.getElementById(`LocalizationDrawerForm-${localizationId}`);
    };
    const getSuggestion = (element) => {
      const localizationId = getLocalizationId(element);
      if (localizationId === '') return null;
      return document.querySelector(
        `localization-auto-suggestion[data-localization-id="${CSS.escape(localizationId)}"]`
      );
    };
    const submitCountry = (element, countryCode) => {
      const form = getRootForm(element);
      const input = form?.querySelector('[data-localization-country-input]');
      if (countryCode && form && input) {
        input.value = countryCode;
        form.submit();
      }
    };
    const hideAutoSuggest = (element) => {
      const suggestion = getSuggestion(element);
      if (!(suggestion instanceof HTMLElement)) return;
      suggestion.hidden = true;
      suggestion.removeAttribute('data-localization-target-country');
    };
    const showAutoSuggest = (element, targetCountry) => {
      const suggestion = getSuggestion(element);
      if (!(suggestion instanceof HTMLElement) || !targetCountry) return;

      const textNode = suggestion.querySelector('[data-localization-auto-suggest-text]');
      if (!(textNode instanceof HTMLElement)) {
        return;
      }

      suggestion.setAttribute('data-localization-target-country', targetCountry);
      textNode.textContent = suggestion.dataset.autoDetectedTemplate || '';
      suggestion.hidden = false;
    };

    class LocalizationDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.localizationDrawerBound === 'true') return;
        this.dataset.localizationDrawerBound = 'true';

        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;

          const countryItem = event.target.closest('[data-country-code]');
          if (countryItem instanceof HTMLElement) {
            const countryCode = countryItem.getAttribute('data-country-code');
            hideAutoSuggest(this);
            submitCountry(this, countryCode);
          }
        });
      }
    }

    class AutoSwitchSuggestion extends HTMLElement {
      connectedCallback() {
        if (this.dataset.localizationAutoSuggestionBound === 'true') return;
        this.dataset.localizationAutoSuggestionBound = 'true';

        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;

          if (event.target.closest('.localization-auto-suggestion__switch-button')) {
            const targetCountry = this.getAttribute('data-localization-target-country');
            if (targetCountry) {
              submitCountry(this, targetCountry);
            }
            return;
          }

          if (event.target.closest('.localization-auto-suggestion__stay-button')) {
            this.hidden = true;
            this.removeAttribute('data-localization-target-country');
          }
        });
      }
    }

    if (!customElements.get('localization-drawer')) {
      customElements.define('localization-drawer', LocalizationDrawer);
    }

    if (!customElements.get('localization-auto-suggestion')) {
      customElements.define('localization-auto-suggestion', AutoSwitchSuggestion);
    }

    if (window.Shopify && window.Shopify.designMode) return;

    const readBrowserCountryCodes = () => {
      const localeList = Array.from(new Set([...(navigator.languages || []), navigator.language].filter(Boolean)));
      const fallbackLanguageToCountry = {
        en: 'US',
        zh: 'CN',
        fr: 'FR',
        de: 'DE',
        es: 'ES',
        it: 'IT',
        ja: 'JP',
        ko: 'KR',
        pt: 'PT',
        nl: 'NL',
        ru: 'RU',
      };
      const browserCountryCodes = [];

      localeList.forEach((localeCode) => {
        let regionCode = '';
        try {
          const locale = new Intl.Locale(localeCode);
          regionCode = (locale.region || '').toUpperCase();
          if (!regionCode && locale.language && fallbackLanguageToCountry[locale.language]) {
            regionCode = fallbackLanguageToCountry[locale.language];
          }
        } catch (_error) {
          const normalized = String(localeCode).replace('_', '-');
          const parts = normalized.split('-');
          if (parts.length > 1) {
            regionCode = parts[parts.length - 1].toUpperCase();
          } else if (fallbackLanguageToCountry[parts[0]]) {
            regionCode = fallbackLanguageToCountry[parts[0]];
          }
        }

        if (regionCode && browserCountryCodes.includes(regionCode) === false) {
          browserCountryCodes.push(regionCode);
        }
      });

      return browserCountryCodes;
    };

    const root = getDrawers()[0];
    if (!(root instanceof HTMLElement)) return;

    const suggestion = getSuggestion(root);
    if (!(suggestion instanceof HTMLElement)) return;

    const currentCountry = (suggestion.getAttribute('data-current-country') || '').toUpperCase();
    if (!currentCountry) return;

    const countryItems = Array.from(root.querySelectorAll('[data-country-code]'));
    const availableCountryCodes = countryItems.reduce((countryCodes, item) => {
      if (!(item instanceof HTMLElement)) return countryCodes;

      const countryCode = (item.getAttribute('data-country-code') || '').toUpperCase();
      if (countryCode) {
        countryCodes.push(countryCode);
      }

      return countryCodes;
    }, []);

    const browserCountryCodes = readBrowserCountryCodes();
    const targetCountry = browserCountryCodes.find((countryCode) => {
      return availableCountryCodes.includes(countryCode) && countryCode !== currentCountry;
    });
    if (!targetCountry) return;

    const promptCacheKey = `localization-drawer-auto-prompt-${currentCountry}-${targetCountry}`;
    let hasPromptedInSession = false;
    try {
      hasPromptedInSession = window.sessionStorage.getItem(promptCacheKey) === '1';
    } catch (_error) {}
    if (hasPromptedInSession) return;

    try {
      window.sessionStorage.setItem(promptCacheKey, '1');
    } catch (_error) {}

    showAutoSuggest(root, targetCountry);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('search-drawer')) return;

    const ANIMATED_VISIBLE_CLASSES = ['opacity-100', 'translate-y-0'];
    const ANIMATED_HIDDEN_CLASSES = ['opacity-0', 'translate-y-2'];
    const VISIBILITY_TRANSITION_MS = 220;
    const SEARCH_LIMIT = 4;
    const PREDICTIVE_SEARCH_SECTION_ID = 'predictive-search';

    class SearchDrawer extends HTMLElement {
      constructor() {
        super();
        this.parser = new DOMParser();
        this.visibilityTimers = new WeakMap();
        this.predictiveSearchPath = window.Theme?.routes?.predictive_search_url || '/search/suggest';
        this.searchAbortController = null;
        this.searchDebounceTimer = 0;
        this.activeRequestId = 0;
        this.handleClick = this.handleClick.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
      }

      connectedCallback() {
        this.input = this.querySelector('.search__input');
        this.resultsPanel = this.querySelector('.search-drawer-results-panel');
        this.resultsCta = this.querySelector('.search-drawer-results-cta');
        this.resultsAnchor = this.querySelector('.search-drawer-results-link a');

        if (
          !(this.input instanceof HTMLInputElement) ||
          !(this.resultsPanel instanceof HTMLElement) ||
          !(this.resultsCta instanceof HTMLElement)
        ) {
          return;
        }

        this.addEventListener('click', this.handleClick);
        this.addEventListener('input', this.handleInput);
        this.addEventListener('header-drawer:open', this.handleDrawerOpen);

        this.syncResultsLink();

        if (this.input.value.trim()) {
          this.queueResultsRequest();
          return;
        }

        this.clearResults();
        this.setLoading(false);
        this.syncViewState();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('input', this.handleInput);
        this.removeEventListener('header-drawer:open', this.handleDrawerOpen);
        this.searchAbortController?.abort();
        window.clearTimeout(this.searchDebounceTimer);
        this.clearVisibilityTimer(this.resultsPanel);
        this.clearVisibilityTimer(this.resultsCta);
      }

      clearVisibilityTimer(element) {
        if (!(element instanceof HTMLElement)) return;

        const existingTimer = this.visibilityTimers.get(element);
        if (!existingTimer) return;

        window.clearTimeout(existingTimer);
        this.visibilityTimers.delete(element);
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);
      }

      setAnimatedVisibility(element, isVisible) {
        if (!(element instanceof HTMLElement)) return;

        this.clearVisibilityTimer(element);

        if (isVisible) {
          element.hidden = false;
          element.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(() => {
            element.classList.remove(...ANIMATED_HIDDEN_CLASSES);
            element.classList.add(...ANIMATED_VISIBLE_CLASSES);
          });
          return;
        }

        element.classList.remove(...ANIMATED_VISIBLE_CLASSES);
        element.classList.add(...ANIMATED_HIDDEN_CLASSES);
        element.setAttribute('aria-hidden', 'true');
        this.visibilityTimers.set(
          element,
          window.setTimeout(() => {
            element.hidden = true;
            this.visibilityTimers.delete(element);
          }, VISIBILITY_TRANSITION_MS)
        );
      }

      clearResults() {
        this.resultsPanel.replaceChildren();
        this.setAnimatedVisibility(this.resultsCta, false);
      }

      hasResults() {
        return this.resultsPanel.childElementCount > 0;
      }

      syncResultsLink() {
        if (!(this.resultsAnchor instanceof HTMLAnchorElement) || !(this.input instanceof HTMLInputElement)) return;

        const searchUrl = new URL(this.resultsAnchor.getAttribute('href') || '/search', window.location.origin);
        const term = this.input.value.trim();

        if (term) {
          searchUrl.searchParams.set('q', term);
        } else {
          searchUrl.searchParams.delete('q');
        }

        this.resultsAnchor.href = searchUrl.toString();
      }

      syncViewState() {
        const hasTerm = this.input.value.trim() !== '';
        const isLoading = this.classList.contains('is-loading');
        this.setAnimatedVisibility(this.resultsPanel, hasTerm && (isLoading || this.hasResults()));
        this.syncResultsLink();
      }

      getPredictiveSearchUrl(term) {
        const url = new URL(this.predictiveSearchPath, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'query,product,page,collection');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[limit]', String(SEARCH_LIMIT));
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('section_id', PREDICTIVE_SEARCH_SECTION_ID);
        return url;
      }

      async requestResults() {
        const searchTerm = this.input.value.trim();
        if (!searchTerm) {
          this.searchAbortController?.abort();
          this.clearResults();
          this.setLoading(false);
          this.syncViewState();
          return;
        }

        this.searchAbortController?.abort();
        this.searchAbortController = new AbortController();
        const requestId = ++this.activeRequestId;
        this.setLoading(true);
        this.syncViewState();

        try {
          const response = await fetch(this.getPredictiveSearchUrl(searchTerm).toString(), {
            signal: this.searchAbortController.signal,
          });
          if (!response.ok) throw new Error('Search request failed');

          const markup = await response.text();
          if (requestId !== this.activeRequestId) return;

          const parsedMarkup = this.parser.parseFromString(markup, 'text/html');
          const predictiveResults = parsedMarkup.querySelector('#predictive-search-results');
          const totalResults = Number(predictiveResults?.dataset.totalResults || 0);
          const productResults = Number(predictiveResults?.dataset.productResults || 0);

          this.clearResults();

          if (predictiveResults instanceof HTMLElement) {
            if (totalResults > 0) {
              this.setAnimatedVisibility(this.resultsCta, productResults > 0);
            }

            predictiveResults.id = 'search-drawer-predictive-search-results';
            this.resultsPanel.replaceChildren(predictiveResults);
          }
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
          this.clearResults();
        } finally {
          if (requestId === this.activeRequestId) {
            this.setLoading(false);
            this.syncViewState();
          }
        }
      }

      queueResultsRequest() {
        this.setLoading(this.input.value.trim() !== '');
        this.syncViewState();
        window.clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = window.setTimeout(() => {
          this.requestResults();
        }, 200);
      }

      handleClick(event) {
        if (!(event.target instanceof Element)) return;

        if (event.target.closest('.search__field .clear')) {
          this.input.value = '';
          this.queueResultsRequest();
          this.input.focus();
          return;
        }

        if (event.target.closest('[data-header-drawer-close], .header-drawer-shell__mask')) {
          window.__headerDrawerShell?.close?.(this);
        }
      }

      handleInput(event) {
        if (event.target === this.input) {
          this.queueResultsRequest();
        }
      }

      handleDrawerOpen(event) {
        if (event.target !== this) {
          return;
        }

        this.input?.focus();
      }
    }

    customElements.define('search-drawer', SearchDrawer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    (() => {
    const vimeoPosterCache = new Map();

    const bindVimeoPosterImages = (root = document) => {
      const posters = root.querySelectorAll('img[data-vimeo-poster][data-vimeo-oembed-url]');

      posters.forEach(async (poster) => {
        if (!(poster instanceof HTMLImageElement)) return;
        if (poster.hasAttribute('data-vimeo-poster-bound')) return;

        const oembedUrl = poster.dataset.vimeoOembedUrl;
        if (!oembedUrl) return;

        poster.setAttribute('data-vimeo-poster-bound', 'true');

        try {
          let thumbnailUrlPromise = vimeoPosterCache.get(oembedUrl);

          if (!thumbnailUrlPromise) {
            thumbnailUrlPromise = fetch(oembedUrl)
              .then((response) => {
                if (!response.ok) throw new Error('Unable to load Vimeo thumbnail');

                return response.json();
              })
              .then((data) => data.thumbnail_url);
            vimeoPosterCache.set(oembedUrl, thumbnailUrlPromise);
          }

          const thumbnailUrl = await thumbnailUrlPromise;
          if (thumbnailUrl) poster.src = thumbnailUrl;
        } catch {
          poster.removeAttribute('data-vimeo-poster-bound');
        }
      });
    };

    const bindAutoplayPosterTransition = (root = document) => {
      const autoplayMedia = root.querySelectorAll('deferred-media[data-autoplay-with-poster]');

      autoplayMedia.forEach((media) => {
        if (media.hasAttribute('data-autoplay-poster-bound')) return;

        const posterButton = media.querySelector('.deferred-media__poster-button');
        if (!(posterButton instanceof HTMLElement)) return;

        const onReady = () => {
          posterButton.classList.add('deferred-media__playing');
          media.setAttribute('data-media-loaded', 'true');
          media.setAttribute('data-media-state', 'playing');
          if (typeof media.updatePlayPauseHint === 'function') {
            media.isPlaying = true;
            media.updatePlayPauseHint(true);
          }
        };

        const video = media.querySelector('video');
        if (video instanceof HTMLVideoElement) {
          if (video.readyState >= 2) {
            onReady();
          } else {
            video.addEventListener('loadeddata', onReady, { once: true });
            video.addEventListener('canplay', onReady, { once: true });
          }
        } else {
          const iframe = media.querySelector('iframe');
          if (iframe instanceof HTMLIFrameElement) {
            iframe.addEventListener('load', onReady, { once: true });
          }
        }

        media.setAttribute('data-autoplay-poster-bound', 'true');
      });
    };

    bindVimeoPosterImages();
    bindAutoplayPosterTransition();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target instanceof Element || event.target instanceof Document ? event.target : document;
      bindVimeoPosterImages(root);
      bindAutoplayPosterTransition(root);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target instanceof Element || event.target instanceof Document ? event.target : document;
      bindVimeoPosterImages(root);
      bindAutoplayPosterTransition(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
